import {ProductReviewData} from '../../ui/ProductReviewData'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {PRODUCT_REVIEW_BASE_DATA_SECTION, PRODUCT_REVIEW_DESCRIPTION_SECTION} from '../productReviewDataMap'

export const ProductInformationSection = () => {
  return (
    <ProductReviewSection title="Product Information" icon="info">
      <ProductReviewData sections={[PRODUCT_REVIEW_BASE_DATA_SECTION, PRODUCT_REVIEW_DESCRIPTION_SECTION]} />
    </ProductReviewSection>
  )
}
